import { useTranslation } from 'react-i18next'
import { usePageTitle } from '@/hooks/usePageTitle'
import { PageHero, ScrollReveal } from '@/components/ui'

interface PrivacySection {
  title: string
  text: string
}

export default function Privacy() {
  const { t } = useTranslation()
  usePageTitle('privacyPage.meta.title', 'privacyPage.meta.description')

  const sections = t('privacyPage.sections', { returnObjects: true }) as PrivacySection[]

  return (
    <main id="main-content">
      <PageHero
        title={t('privacyPage.hero.title')}
        subtitle={t('privacyPage.hero.subtitle')}
      />

      <section className="bg-surface py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <div className="space-y-0">
            {sections.map((section, index) => (
              <ScrollReveal key={section.title} delay={index * 0.05}>
                <div className="py-10 border-b border-border last:border-b-0">
                  <h2 className="font-display text-xl md:text-2xl text-heading mb-4">
                    {section.title}
                  </h2>
                  <p className="text-text leading-relaxed whitespace-pre-line">
                    {section.text}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  )
}
